module.exports = __webpack_public_path__ + "img/main-batt-low.0a8d7c5a.svg";